(function () {
  'use strict';

  // URL marker used when the shopper's size can't be carried over to the new color
  // (missing or sold out there). The destination page reads it and forces a fresh
  // size choice instead of silently defaulting to another size.
  var CHOOSE_SIZE_PARAM = 'choose_size';
  var HIGHLIGHT_CLASS = 'color-switch-size-highlight';

  function ProductGroupSwitcher() {
    this.injectStyles();
    this.bindEvents();
    this.handleChooseSizeOnLoad();
  }

  ProductGroupSwitcher.prototype = {
    bindEvents: function () {
      var self = this;

      document.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('[data-product-color-input]')) {
          self.handleColorChange(e.target);
        }
      });
    },

    // Read the size the shopper currently has selected. Grouped products expose a
    // single "size" option, rendered as pill/swatch radios or a dropdown.
    getSelectedSize: function () {
      var checked = document.querySelector(
        '.product-form__input--pill input[type="radio"]:checked, .product-form__input--swatch input[type="radio"]:checked'
      );
      if (checked) return checked.value;

      var select = document.querySelector('.product-form__input--dropdown select');
      if (select && select.value) return select.value;

      return null;
    },

    appendParam: function (url, key, value) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + key + '=' + encodeURIComponent(value);
    },

    handleColorChange: function (input) {
      var productUrl = input.getAttribute('data-product-url');
      if (!productUrl) return;

      var size = this.getSelectedSize();

      if (size) {
        var map = null;
        try {
          map = JSON.parse(input.getAttribute('data-variant-map') || 'null');
        } catch (err) {
          map = null;
        }

        var entry = map ? map[size] : null;

        if (entry && entry.available) {
          // Same size is available on the target color: preselect it via ?variant=.
          productUrl = this.appendParam(productUrl, 'variant', entry.id);
        } else {
          // Size missing or sold out on the target color: open with no size selected.
          productUrl = this.appendParam(productUrl, CHOOSE_SIZE_PARAM, size);
        }
      }

      window.location.href = productUrl;
    },

    // ---- Destination side ----

    getProductInfo: function () {
      return (
        document.querySelector('product-info[id^="MainProduct-"]') ||
        document.querySelector('product-info')
      );
    },

    handleChooseSizeOnLoad: function () {
      var self = this;

      var run = function () {
        var params = new URLSearchParams(window.location.search);
        if (!params.has(CHOOSE_SIZE_PARAM)) return;

        self.clearSizeSelection();

        // Drop the marker so a refresh/share doesn't re-trigger the empty state.
        params.delete(CHOOSE_SIZE_PARAM);
        var query = params.toString();
        var newUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, '', newUrl);
        }
      };

      // The switcher script is deferred, so it may run before <product-form> has
      // upgraded. Wait for the DOM to be ready before touching the buy area.
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run, { once: true });
      } else {
        run();
      }
    },

    clearSizeSelection: function () {
      var info = this.getProductInfo();
      if (!info) return;

      // Uncheck the size that the target product auto-selected.
      info
        .querySelectorAll(
          '.product-form__input--pill input[type="radio"]:checked, .product-form__input--swatch input[type="radio"]:checked'
        )
        .forEach(function (radio) {
          radio.checked = false;
        });

      // Clear the variant id so nothing can be added until a size is chosen.
      var idInput = info.querySelector('input[name="id"]');
      if (idInput) idInput.value = '';

      // Disable the buy buttons and prompt for a size. <product-form> may not be
      // upgraded yet, so wait for its definition before calling its method.
      var message =
        (window.variantStrings && window.variantStrings.chooseSize) || 'Escolha um tamanho';
      var disableButtons = function () {
        var productForm = info.querySelector('product-form');
        if (productForm && typeof productForm.toggleSubmitButton === 'function') {
          productForm.toggleSubmitButton(true, message);
        }
      };
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('product-form').then(disableButtons);
      } else {
        disableButtons();
      }

      // Highlight the size selector and bring it into view.
      var sizeFieldset = info.querySelector(
        '.product-form__input--pill, .product-form__input--swatch, .product-form__input--dropdown'
      );
      if (sizeFieldset) {
        sizeFieldset.classList.add(HIGHLIGHT_CLASS);
        sizeFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });

        var clear = function () {
          sizeFieldset.classList.remove(HIGHLIGHT_CLASS);
          sizeFieldset.removeEventListener('change', clear);
        };
        // Once the shopper picks a size the normal variant flow takes over.
        sizeFieldset.addEventListener('change', clear);
      }
    },

    injectStyles: function () {
      if (document.getElementById('color-switch-size-highlight-styles')) return;

      var style = document.createElement('style');
      style.id = 'color-switch-size-highlight-styles';
      style.textContent =
        '.' + HIGHLIGHT_CLASS + ' .custom-variant-label,' +
        '.' + HIGHLIGHT_CLASS + ' .form__label{color:#d92d20;}' +
        '.' + HIGHLIGHT_CLASS + '{animation:color-switch-size-shake .4s ease;}' +
        '@keyframes color-switch-size-shake{' +
        '0%,100%{transform:translateX(0);}' +
        '20%{transform:translateX(-8px);}' +
        '40%{transform:translateX(8px);}' +
        '60%{transform:translateX(-5px);}' +
        '80%{transform:translateX(5px);}}' +
        '@media (prefers-reduced-motion: reduce){.' + HIGHLIGHT_CLASS + '{animation:none;}}';
      document.head.appendChild(style);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      new ProductGroupSwitcher();
    });
  } else {
    new ProductGroupSwitcher();
  }
})();
